module.exports = __webpack_public_path__ + "static/media/street.dd5922da.png";